import React from 'react'

const SvgDevicesOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16 11a1 1 0 00-1 1v8a1 1 0 001 1h4a1 1 0 001-1v-8a1 1 0 00-1-1h-4zm1.5 8a.5.5 0 000 1h1a.5.5 0 000-1h-1z'
    />
    <path d='M3.75 2.039A1.75 1.75 0 002 3.789V16.25c0 .967.784 1.75 1.75 1.75h5.21l-1.024 2.038H7a1 1 0 100 2h6.799a2.99 2.99 0 01-.799-2h-2.825L11.197 18H13v-2H4V4.04h16V9c.768 0 1.47.289 2 .764V3.789a1.75 1.75 0 00-1.75-1.75H3.75z' />
    <path d='M21 17.832V12a1 1 0 00-1-1v5h-5v2h5.25c.268 0 .523-.06.75-.168zM15 20.038A.998.998 0 0016 21h2a1 1 0 00-1-.962h-2z' />
  </svg>
)

export default SvgDevicesOutline
